"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureFlagContext = exports.FeatureFlagProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Hook used to enable or disable Feature Flag toggle.
 * @function updateFeatureFlag
 * @param {Node} children - Node.
 * @param {Array} featureFlags - This argument contains array of objects with toggles details.
 * @example
 * 
 * Add FeatureFlagProvider import in index.js file.
 * import {FeatureFlagProvider} from '@livongo/utilities/hooks/useFeatureFlag';
 * <FeatureFlagProvider featureToggles={toggles}>{children}</FeatureFlagProvider>

 * Add import to get FeatureFlagContext
 * import {useFeatureFlagContext} from '@livongo/utilities/hooks/useFeatureFlag';
 * 
 * This method will help us to enable or disable toggle.
 * updateFeatureFlag({
 *      featureName = 'enable_MH_Websdk,
        oneAppActive = false,
        legacyActive = false,
 * });
 * @returns {void}
 */

const FeatureFlagContext = /*#__PURE__*/(0, _react.createContext)();
const FeatureFlagProvider = _ref => {
  let {
    children,
    featureFlags: initialFlags
  } = _ref;
  const [featureFlags, setFeatureFlags] = (0, _react.useState)(initialFlags || []);
  const value = (0, _react.useMemo)(() => ({
    featureFlags,
    updateFeatureFlag: _ref2 => {
      let {
        featureName,
        oneAppActive = false,
        legacyActive = false
      } = _ref2;
      const featureExist = initialFlags.find(obj => obj.name === featureName);
      if (featureExist !== null && featureExist !== void 0 && featureExist.name) {
        featureExist.oneAppActive = oneAppActive;
        featureExist.legacyActive = legacyActive;
        setFeatureFlags(initialFlags);
      } else {
        return "This ".concat(featureName, " flag doesn't exist in JSON files.");
      }
    }
  }), [featureFlags, initialFlags]);
  (0, _react.useEffect)(() => {
    setFeatureFlags([...initialFlags]);
  }, [initialFlags]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FeatureFlagContext.Provider, {
    value: value,
    children: children
  });
};
exports.FeatureFlagProvider = FeatureFlagProvider;
const useFeatureFlagContext = () => (0, _react.useContext)(FeatureFlagContext);
exports.useFeatureFlagContext = useFeatureFlagContext;